import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { LazyTheWestTermsContent } from './LazyTheWestTermsContent'

export const TheWestTermsContentRegistration = createRegisterableComponent(
    'the-west-terms',
    () => <LazyTheWestTermsContent />,
)
